import { createContext, useContext } from 'react';

const HeaderContext = createContext({
  headerContent: null,
  setHeaderContent: () => {}
});

export const HeaderProvider = HeaderContext.Provider;

export const useHeader = () => useContext(HeaderContext);
